import Gallery from "../cards/Details/Gallery";
import Title from "../cards/Details/Title";
import Images from "../cards/Details/Images";
import Options from "../cards/Details/Options";
import {Helmet} from "react-helmet-async";
import {useLoaderData} from "react-router";
import {useUrl} from "../store/Urls";
import {useMemo} from "react";
import VideoCardDetails from "../cards/VideoCardDetails";

const Details = () => {
    const projectsUrl = useUrl((store) => store.projectsUrl)
    const project = useLoaderData();

    const {
        project_name,
        description,
        main_imgs,
        gallery_imgs,
        buttons_url,
        options,
        path,
    } = project;
    const folderUrl = projectsUrl + path
    const getBtnVideo = useMemo(() => {
        return buttons_url
            ? Object.entries(buttons_url).map(([name, {url, video, btn_text}]) => ({
                name,
                url,
                path,
                video,
                btnText: btn_text,
            }))
            : [
                {
                    name: "Breakdown",
                    url: "",
                    path: "",
                    video: "",
                    btnText: "VFX Breakdown",
                },
                {
                    name: "Official video",
                    url: "",
                    path: "",
                    video: "",
                    btnText: "Official video",
                },
            ];
    }, [buttons_url, folderUrl]);

    const getMainImages = useMemo(() => {
        return Array.from({length: main_imgs}, (_, i) => {
            const img = `${folderUrl}/images/main${i + 1}.jpg`;
            const poster = `${folderUrl}/images/main${i + 1}poster.jpg`;
            const alt = `${project_name} image${i + 1}`;
            return {img, poster, alt};
        });
    }, [main_imgs, folderUrl, project_name]);

    const getDataArr = useMemo(() => {
        return Object.entries(options).map(([title, desc]) => ({title, desc}));
    }, [options]);

    return (
        <main className="main details">
            <Helmet>
                <title>Project {project_name}</title>
                <meta content={`Project ${project_name}`} property="og:title"/>
                <meta content={`Project ${project_name}`} property="twitter:title"/>
                <meta name="description" content={`Project ${project_name}`}/>
            </Helmet>
            <section className="container-80 mt-80 p_top_d">
                <Title title={project_name}/>
                <section className="container-80 mt-52">
                    <div className="details__grid-cards flex gap-16 p-25r fs-20">
                        {getBtnVideo.map((card, i) => card.url && <VideoCardDetails key={i} props={card}/>)}
                    </div>
                </section>
                <Options data={getDataArr}/>
                {/*<p className="regular gray mt-16 p-25r text-center">{description}</p>*/}
                <p className="regular gray mt-52 p-25r text-center description">
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                    A ab aliquam aliquid amet architecto atque, consequatur corporis culpa cum deserunt dolor dolores ea
                    earum eius eos error expedita fuga inventore laboriosam laborum, magnam magni molestiae mollitia
                    necessitatibus officiis perspiciatis quae quam quasi qui rerum suscipit tenetur vel
                    velit vero voluptate.</p>
                <Gallery images={gallery_imgs} path={folderUrl}/>
                <Images getImages={getMainImages} name={project_name}/>
            </section>

        </main>
    )
}
export default Details